//oemID
function getOem() {
    var oem = '';
    $.support.cors = true;
    $.ajax({
        url: './static/config.json',
        type: 'GET',
        async: false,
        dataType: 'json',
        success: function(msg) {
            oem = msg;
        }
    });
    return oem;
};
var baseData = getOem();
var seq = -1;
//获取语言
var listLan = baseData.lanList;
var listName = {};
var listFile = {};
for (var i = 0; i < listLan.length; i++) {
    listName[listLan[i]['lan']] = listLan[i]['name'];
    listFile[listLan[i]['lan']] = listLan[i]['file'];
};
//选择语言
function getLan(list, lan) {
    var Translate = '';
    var data = {};
    $.support.cors = true;
    $.ajax({
        url: './static/lan/' + list[lan] + '.xml',
        type: 'GET',
        async: false,
        dataType: 'xml',
        success: function(msg) {
            Translate = $(msg).find('Translate');
            data[lan] = {};
            $(Translate).children().each(function() {
                if ($(this).text() === '') {
                    data[lan][this.tagName] = this.tagName;
                } else {
                    data[lan][this.tagName] = $(this).text();
                };
            });
        }
    });
    return data;
};
var curWwwPath = window.document.location.href;
var ProHeader = curWwwPath.split("//")[0] + "//";
var IP = curWwwPath.split("//")[1].split("/")[0];
// var ProHeader = 'http://';
// var IP = '192.168.2.235:8099';
var socket = '';
// if (ProHeader.indexOf('https') >= 0) {
//     socket = new WebSocket("wss://127.0.0.1:9050");
// } else {
//     socket = new WebSocket("ws://127.0.0.1:9010");
// };
window.ICloudStatus = function(state) {
    // if ($cloud !== '') {
    //     $cloud.hsState.get(state);
    // };
    fun.hsState.get(state);
};
var fun = {
    posID: baseData.POSID,
    domain: document.domain,
    getPosID: function() {
        var posID = sessionStorage.getItem('posID');
        return posID === null ? this.posID : posID;
    },
    setPosID: function(id) {
        sessionStorage.setItem('posID', id);
        this.posID = id;
    },
    ajaxSet: function(obj) {
        if (typeof obj !== 'string' && obj.header) {
            seq+=1
            obj.header.seq = seq
        }
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        var myDate = new Date();
        myDate.setTime(-1000);
        if (keys) {
            for (var i = keys.length; i--;) {
                document.cookie = keys[i] + "=; expires=" + myDate.toGMTString();
                document.cookie = keys[i] + "=; expires=" + myDate.toGMTString() + ";domain=" + this.domain + ";";
                document.cookie = keys[i] + "=; expires=" + myDate.toGMTString() + ";domain=" + this.domain.match(/\.\S+/)[0] + ";";
            };
        };
        var url = obj.ip + '/webapi' + this.getPosID() + '/' + obj.type + ';jus_duplex=web';
        var result = '';
        var cT = 'application/xml;charset=utf-8';
        var cTS = 'xml';
        if (obj.cType !== undefined) {
            cT = 'application/json;charset=utf-8';
            cTS = 'json';
        };
        $.ajax({
            url: url,
            type: 'POST',
            contentType: cT,
            async: obj.async || false,
            dataType: cTS,
            data: obj.xml,
            timeout: 3000,
            beforeSend: function(request) {
                // request.setRequestHeader("test", 3);
            },
            success: function(msg, status, xhr) {
                result = { data: msg, status: status, xhr: xhr };
                if (obj.method) {
                    obj.method(msg, status, xhr);
                };
            },
            error: function(msg) {
                result = '';
                if (obj.method) {
                    obj.method('');
                };
            }
        });
        return result;
    },
    getCss: function(name) {
        var result = '';
        $.ajax({
            url: './static/' + name + '.css',
            type: 'GET',
            async: false,
            dataType: 'text',
            success: function(msg) {
                result = msg;
            }
        });
        return result;
    },
    shareList: {
        list: []
    },
    ajaxH: {
        session: '',
        user: '',
        repeat: function() {

        },
    },
    listName: listName,
    listFile: listFile,
    lanSave: {},
    lanNow: { lan: '' },
    ProHeader: ProHeader,
    cloudIP: IP,
    cloudName: ProHeader + IP,
    socket: { set: '', wsS: true, wsT: false },
    socketObj: { set: {} },
    hsState: {
        state: {},
        start: false,
        data: '',
        $this: '',
        get: function(state) {
            var that = this;
            // if (this.start) {
            this.state = JSON.parse(state)[0];
            for (var key in this.state) {
                if (this.$this.myDevices) {
                    if (this.$this.myDevices[key]) {
                        this.$this.myDevices[key].online = this.state[key] - 0 ? true : false;
                    } else {
                        this.$this.myDevices.forEach(function (item, index) {
                            if (item.id === key) {
                                that.$this.myDevices[index].online = that.state[key] - 0 ? true : false;
                            }
                        })
                    }
                }
            };
            console.log('state-sucess:' + state);
            // this.$this.timeCountHs = setTimeout(function() {
            //     clearTimeout(this.$this.timeCountHs);
            //     this.$this.getStateHs();
            // }.bind(this), 2000);
            // try {
            //     $('#ocx')[0].IGetCloudIDStatus(this.data);
            // } catch (error) {
            //     this.state = JSON.parse(this.data.replace(/,/g, ':0,').replace(/}/g, ':0}'));
            //     this.start = false;
            // };
            // };
        }
    },
    ie10Model: function(event, key) {
        var val = event.target.value;
        if (key.indexOf('.') >= 0) {
            var keys = key.split('.');
            var tar = this[keys[0]];
            keys.shift();
            keys.forEach(function(v, index) {
                if (index === keys.length - 1) {
                    tar[v] = val;
                } else {
                    tar = tar[v];
                };
            });
        } else {
            this[key] = val
        };
    },
    base64: function() {
        // private property
        var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

        // public method for encoding
        this.encode = function(input) {
            var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;
            input = _utf8_encode(input);
            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output +
                    _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                    _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
            }
            return output;
        }

        // public method for decoding
        this.decode = function(input) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            while (i < input.length) {
                enc1 = _keyStr.indexOf(input.charAt(i++));
                enc2 = _keyStr.indexOf(input.charAt(i++));
                enc3 = _keyStr.indexOf(input.charAt(i++));
                enc4 = _keyStr.indexOf(input.charAt(i++));
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
                output = output + String.fromCharCode(chr1);
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }
            output = _utf8_decode(output);
            return output;
        }

        // private method for UTF-8 encoding
        var _utf8_encode = function(string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";
            for (var n = 0; n < string.length; n++) {
                var c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }
            return utftext;
        }

        // private method for UTF-8 decoding
        var _utf8_decode = function(utftext) {
            var c1;
            var c2;
            var string = "";
            var i = 0;
            var c = c1 = c2 = 0;
            while (i < utftext.length) {
                c = utftext.charCodeAt(i);
                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }
            }
            return string;
        }
    },
    hashEncryption: function(s) {
        var chrsz = 8;
        var hexcase = 0;

        function safe_add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        }

        function S(X, n) { return (X >>> n) | (X << (32 - n)); }

        function R(X, n) { return (X >>> n); }

        function Ch(x, y, z) { return ((x & y) ^ ((~x) & z)); }

        function Maj(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)); }

        function Sigma0256(x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)); }

        function Sigma1256(x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)); }

        function Gamma0256(x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)); }

        function Gamma1256(x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)); }

        function core_sha256(m, l) {
            var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
            var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
            var W = new Array(64);
            var a, b, c, d, e, f, g, h, i, j;
            var T1, T2;
            m[l >> 5] |= 0x80 << (24 - l % 32);
            m[((l + 64 >> 9) << 4) + 15] = l;
            for (var i = 0; i < m.length; i += 16) {
                a = HASH[0];
                b = HASH[1];
                c = HASH[2];
                d = HASH[3];
                e = HASH[4];
                f = HASH[5];
                g = HASH[6];
                h = HASH[7];
                for (var j = 0; j < 64; j++) {
                    if (j < 16) W[j] = m[j + i];
                    else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
                    T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
                    T2 = safe_add(Sigma0256(a), Maj(a, b, c));
                    h = g;
                    g = f;
                    f = e;
                    e = safe_add(d, T1);
                    d = c;
                    c = b;
                    b = a;
                    a = safe_add(T1, T2);
                }
                HASH[0] = safe_add(a, HASH[0]);
                HASH[1] = safe_add(b, HASH[1]);
                HASH[2] = safe_add(c, HASH[2]);
                HASH[3] = safe_add(d, HASH[3]);
                HASH[4] = safe_add(e, HASH[4]);
                HASH[5] = safe_add(f, HASH[5]);
                HASH[6] = safe_add(g, HASH[6]);
                HASH[7] = safe_add(h, HASH[7]);
            }
            return HASH;
        }

        function str2binb(str) {
            var bin = Array();
            var mask = (1 << chrsz) - 1;
            for (var i = 0; i < str.length * chrsz; i += chrsz) {
                bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i % 32);
            }
            return bin;
        }

        function Utf8Encode(string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";
            for (var n = 0; n < string.length; n++) {
                var c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        }

        function binb2hex(binarray) {
            var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
            var str = "";
            for (var i = 0; i < binarray.length * 4; i++) {
                str += hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +
                    hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF);
            }
            return str;
        }
        s = Utf8Encode(s);
        return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
    },
    getCookie: function(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + "=")
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1
                var c_end = document.cookie.indexOf(";", c_start)
                if (c_end == -1) c_end = document.cookie.length
                return unescape(document.cookie.substring(c_start, c_end))
            }
        }
        return "";
    },
    xmlEsc: function(string) { //xml特殊字符转义
        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': '&quot;',
            "'": '&apos;'
        };
        return String(string).replace(/[&<>"']/g, function(s) {
            return entityMap[s];
        });
    },
    promptInfo: function(result) {
        var errorCode = {
            100000000: 'K063_100000000',
            100000001: 'K064_100000001',
            100000002: 'K065_100000002',
            100000003: 'K066_100000003',
            100000004: 'K067_100000004',
            100000005: 'K068_100000005',
            100000006: 'K069_100000006',
            100100000: 'K070_100100000',
            100100001: 'K071_100100001',
            100100002: 'K072_100100002',
            100100003: 'K073_100100003',
            100101000: 'K074_100101000',
            100101001: 'K075_100101001',
            100101002: 'K076_100101002',
            100101100: 'K077_100101100',
            100101101: 'K078_100101101',
            100101102: 'K079_100101102',
            100101103: 'K080_100101103',
            100101104: 'K081_100101104',
            100101105: 'K082_100101105',
            100101106: 'K083_100101106',
            100101107: 'K084_100101107',
            100101108: 'K085_100101108',
            100101109: 'K086_100101109',
            100101110: 'K087_100101110',
            100101111: 'K088_100101111',
            100101112: 'K089_100101112',
            100101113: 'K090_100101113',
            100101114: 'K091_100101114',
            100101115: 'K092_100101115',
            100101116: 'K093_100101116',
            100101117: 'K094_100101117',
            100101118: 'K095_100101118',
            100101119: 'K096_100101119',
            100101120: 'K097_100101120',
            100151001: 'K098_100151001',
            100151002: 'K099_100151002',
            100151003: 'K100_100151003',
            100151004: 'K101_100151004',
            100151005: 'K102_100151005',
            100151006: 'K103_100151006',
            100151007: 'K104_100151007',
            100152002: 'K105_100152002',
            100152003: 'K106_100152003',
            100152004: 'K107_100152004',
            100152005: 'K108_100152005',
            100152006: 'K109_100152006',
            100152007: 'K110_100152007'
        }
        return errorCode[result] == undefined ? 'Error code: ' + result : errorCode[result];
    },
    detectOS: function() {
        var sUserAgent = navigator.userAgent;
        var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
        var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
        if (isMac) return "Mac";
        var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
        if (isUnix) return "Unix";
        var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
        if (isLinux) return "Linux";
        if (isWin) {
            return "win";
        }
        return "other";
    },
    browserDetect: function() {
        var IEVersion = function() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6; //IE版本<=7
                }
            } else if (isEdge) {
                return 'edge'; //edge
            } else if (isIE11) {
                return 11; //IE11  
            } else {
                return -1; //不是ie浏览器
            }
        };
        var userAgent = navigator.userAgent;
        var isOpera = userAgent.indexOf("Opera") > -1;
        var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
        var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
        var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
        if (isOpera)
            return 'Opera';
        if (isEdge)
            return 'Edge';
        if (isFF)
            return 'Firefox';
        if (isSafari)
            return 'Safari';
        if (isChrome)
            return 'Chrome';
        if (IEVersion() !== -1)
            return 'IE';
        return '';
    },
    jsonStr: function(c, p) {
        var obj = {
            'cmd': c,
            'param': p
        }
        return JSON.stringify(obj);
    },
    StrByteCountFun: function(str, charset) {
        charset = charset || 'utf-8';
        var total = 0,
            charCode, i, len;
        charset = charset ? charset.toLowerCase() : '';
        if (charset === 'utf-16' || charset === 'utf16') {
            for (i = 0, len = str.length; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode <= 0xffff) {
                    total += 2;
                } else {
                    total += 4;
                }
            }
        } else {
            for (i = 0, len = str.length; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode <= 0x007f) {
                    total += 1;
                } else if (charCode <= 0x07ff) {
                    total += 2;
                } else if (charCode <= 0xffff) {
                    total += 3;
                } else {
                    total += 4;
                }
            }
        }
        return total;
    },
    objToXml: function(obj, key) {
        function createXML() {
            var xmlDoc;
            var aVersions = ["MSXML2.DOMDocument", "MSXML2.DOMDocument.5.0",
                "MSXML2.DOMDocument.4.0", "MSXML2.DOMDocument.3.0",
                "Microsoft.XmlDom"
            ];
            for (var i = 0; i < aVersions.length; i++) {
                try {
                    xmlDoc = new ActiveXObject(aVersions[i]);
                    break;
                } catch (oError) {
                    xmlDoc = document.implementation.createDocument("", "", null);
                    break;
                };
            };
            xmlDoc.async = "false";
            var xml = xmlDoc.createProcessingInstruction("xml", "version='1.0' encoding='utf-8'");
            xmlDoc.appendChild(xml);
            return xmlDoc;
        };

        function trans(obj, key, parent) {
            var type = $.type(obj);
            if (type === 'array') {
                for (var k = 0; k < obj.length; k++) {
                    var v = obj[k];
                    var vp = $.type(v);
                    if (vp === 'object') {
                        trans(v, key, parent);
                    } else if (vp === 'array') {
                        var root = xml.createElement(key);
                        parent.appendChild(root);
                        trans(v, key, root);
                    } else {
                        var root = xml.createElement(key);
                        var tx = xml.createTextNode(v + '');
                        root.appendChild(tx);
                        parent.appendChild(root);
                    };
                };
            } else if (type === 'object') {
                var root = xml.createElement(key);
                for (var k in obj) {
                    var v = obj[k];
                    var vp = $.type(v);
                    if (vp === 'object') {
                        trans(v, k, root);
                    } else if (vp === 'array') {
                        trans(v, k, root);
                    } else {
                        var el = xml.createElement(k);
                        var tx = xml.createTextNode(v + '');
                        el.appendChild(tx);
                        root.appendChild(el);
                    };
                };
                if (parent !== undefined) {
                    parent.appendChild(root);
                } else {
                    xml.appendChild(root);
                };
            };
            return xml;
        };
        var xml = createXML();
        return trans(obj, key);
    },
    xmlToString: function(xmlData) {

        var xmlString;
        //IE
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            xmlString = xmlData.xml;
        }
        // code for Mozilla,Firefox,Opera,etc.
        else {
            xmlString = (new XMLSerializer()).serializeToString(xmlData);
        }
        return xmlString;
    },
    reg: {
        user: {
            num: [1, 60],
            limit: /^[^<>\s\u4e00-\u9fa5]{1,60}$/
        },
        rPwd: {
            num: [6, 16],
            limit: /^(?!\d+$)(?![a-zA-Z]+$)(?=.*?[0-9a-zA-Z\S])(?!.*?[<>])\S{6,16}$/
        },
        lPwd: /^[^<>]{1,60}$/,
        devUser: {
            num: [1, 60],
            limit: /^[^<> \r\n]{1,60}$/
        },
        devPwd: {
            num: [0, 60],
            limit: /^[^<> \r\n]{0,60}$/
        },
        devName: {
            num: [1, 60],
            limit: /^[^<>]{1,60}$/
        },
        devCode: {
            num: [4, 16],
            limit: /^[\da-zA-Z]{4,16}$/
        },
        nick: {
            num: [1, 60],
            limit: /^[^<>]{1,60}$/
        },
        memo: {
            num: [1, 60],
            limit: /^[^<>]{1,60}$/
        }
    }
};
//本地代理端口尝试确认
if (fun.detectOS() === 'win') {
    if (fun.browserDetect() !== 'IE') {
        vSPortTry();
    };
} else if (fun.detectOS() === 'Mac') {
    vSPortTryT();
};

function vSPortTry() {
    var wsk = new WebSocket("ws://127.0.0.1:" + baseData.vSPort);
    wsk.onclose = function(ev) {
        if (wsk.readyState == 3 && baseData.vSNt < 5) {
            baseData.vSNt++;
            baseData.vSPort++;
            vSPortTry();
        }
    }
    wsk.onopen = function(ev) {
        baseData.vSNt = -1;
    }
}

function vSPortTryT() {
    var wsk = new WebSocket("ws://127.0.0.1:9210");
    wsk.onclose = function(ev) {
        if (wsk.readyState == 3 && baseData.vSNt < 3) {
            baseData.vSNt++;
            vSPortTryT();
        } else if (baseData.vSNt >= 3) {
            baseData.vSNt = 1;
            baseData.vSPort = 9010;
            vSPortTry();
        };
    }
    wsk.onopen = function(ev) {
        wsk.send(fun.jsonStr(0, []));
    }
    wsk.onmessage = function(ev) {
        var msg = JSON.parse(ev.data);
        var cm = Number(msg.cmd);
        var res = msg.param;
        switch (cm) {
            case 0:
                baseData.vSPort = res[0];
                baseData.vSNt = -1;
                break;
            default:
        }
    }
}
export { fun, baseData, getLan }


// WEBPACK FOOTER //
// ./src/assets/js/common.js